import { GRAPHQL_QUERY_TEACHERS } from "app/queries";
import { useQuery } from "@apollo/client";
import PageWrapper from "components/PageWrapper";
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import DocumentContext from "components/DocumentContext";
import { useState } from "react";
import { TeacherDialog } from "features/community/TeacherDialog";
import { Teacher } from "@app/shared/types";
import { TeachersPageImageCard } from "./TeachersPageImageCard";
import { sortTeachersByLastName } from "./sortTeachers";

const useStyles = makeStyles((theme) => ({
    cardsContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: theme.spacing(3),
    },
}));

export const TeachersPage = () => {
    const classes = useStyles();
    const { data } = useQuery(GRAPHQL_QUERY_TEACHERS);

    const sortedTeachers = sortTeachersByLastName(data?.teachers || []);

    const [dialogActiveForTeacherId, setDialogActiveForTeacherId] = useState<string | null>(null);
    return (
        <div>
            <DocumentContext title="Teachers" addBrandNameSuffix />
            <PageWrapper data-testid="memberTeachersPage">
                <Typography variant="h2">All Teachers</Typography>

                <div className={classes.cardsContainer}>
                    {sortedTeachers.map((teacher: Teacher) => (
                        <TeachersPageImageCard
                            key={teacher.id}
                            teacher={teacher}
                            onClick={() => setDialogActiveForTeacherId(teacher.id)}
                        />
                    ))}
                </div>

                <TeacherDialog
                    open={Boolean(dialogActiveForTeacherId)}
                    onClose={() => setDialogActiveForTeacherId(null)}
                    teacher={sortedTeachers.find(
                        (teacher: Teacher) => teacher.id === dialogActiveForTeacherId,
                    )}
                />
            </PageWrapper>
        </div>
    );
};
